import TableWithFilters from './TableWithFilters';

export default TableWithFilters;
